import { render, staticRenderFns } from "./FlowPublicBySelf.vue?vue&type=template&id=4511920a&scoped=true"
import script from "./FlowPublicBySelf.vue?vue&type=script&lang=js"
export * from "./FlowPublicBySelf.vue?vue&type=script&lang=js"
import style0 from "./FlowPublicBySelf.vue?vue&type=style&index=0&id=4511920a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4511920a",
  null
  
)

export default component.exports